
<!-- <footer class="footer-content py-6" [ngStyle]="{'background-image': 'url(&quot;' + routeUploadFile+sectionFooter?.background_image + '&quot;)'}"> -->
<footer class="footer-content" [ngStyle]="{ 'background-image': isHome ? 'url(\'' + routeUploadFile + sectionFooter?.background_image + '\')' : 'none',
  'background-color': !isHome ? 'white' : 'none'}"
  [ngClass]="{ 'footer-content-home': isHome, 'footer-content-select': !isHome }">

  <div class="row footer-top-inner-vv footer-box container"
    [ngClass]="{ 'footer-box-home': isHome, 'footer-box-select': !isHome}">
    <div class="col-md-4 col-sm-12 col-12  mt-lg-0 mt-4 py-2 footer-logo">

      <img class="float-xs-left logo" src="{{ routeUploadFile+getClientsSettingAppBooking?.logo_path_three }}"
        align="center" />
      <br>
      <div class="mt-4">
        <a class="subtitle-logo-footer " [ngStyle]="{'color': sectionFooter.color_title}">{{sectionFooter?.info.title}}</a>
        <p class="pt-1 mr-5 pr-5 text-footer" [ngStyle]="{'color': sectionFooter.color_title}">
          {{sectionFooter?.info.title_sub}}
        </p>

        <div class="row mr-5 pr-5 mr-5 pl-0" id="set-icon-footer">
          <div class="col-md-1 col-sm-12 col-12  mt-lg-0 mt-4 py-2">
            <a href="https://wa.me/{{wsp_number}}" target="_blank" rel="noopener noreferrer">
              <i #iconSocialNetworks aria-hidden="true" class="icon-whatsapps"></i>
            </a>
          </div>
          <div class="col-md-1 col-sm-12 col-12  mt-lg-0 mt-4 py-2 ml-3" *ngIf="getClientsSettingAppBooking?.clients_setting_social_networks[1]?.url !== ''">
            <a [href]="getClientsSettingAppBooking?.clients_setting_social_networks[1]?.url" target="_blank" rel="noopener noreferrer">
              <i #iconSocialNetworks aria-hidden="true" class="icon-instagrams"></i>
            </a>
          </div>
          <div class="col-md-1 col-sm-12 col-12  mt-lg-0 mt-4 py-2 ml-3" *ngIf="getClientsSettingAppBooking?.clients_setting_social_networks[3]?.url !== ''">
            <a [href]="getClientsSettingAppBooking?.clients_setting_social_networks[3]?.url" target="_blank" rel="noopener noreferrer">
              <i #iconSocialNetworks aria-hidden="true" class="icon-links"></i>
            </a>
          </div>
          <!-- <div class="col-md-1 col-sm-12 col-12  mt-lg-0 mt-4 py-2 ml-3" *ngIf="getClientsSettingAppBooking?.clients_setting_social_networks[0]?.url != ''">
            <a [href]="getClientsSettingAppBooking?.clients_setting_social_networks[0]?.url" target="_blank" rel="noopener noreferrer">
              <i #iconSocialNetworks aria-hidden="true" class="icon-facebooks"></i>
            </a>
          </div> -->
          <div class="col-md-8 col-sm-12 col-12  mt-lg-0 mt-4 py-2 ml-3">

          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8 col-sm-6 mt-lg-0 mt-4 py-4" id="footer-info">
      <div class="row pl-0 flex-nowrap" id="footer-title-links">
        <div class="col-md-2 col-sm-6 mt-lg-0 mt-4 ">
          <div class="footer-lavi">
            <h3 class="mb-3 footer_title" [ngStyle]="{'color': sectionFooter.color_title}">COMPAÑÍA</h3>
                       <ul class="footer-list-info pt-3">
              <li>
                <a href="javascript:void(0);" (click)="onLinkAbout('')">
                  Nosotros
                </a>
              </li>
              <!-- <li>
                <a href="javascript:void(0);" (click)="onLinkAbout('valores')">

                </a>
              </li> -->
              <li>
                <a href="javascript:void(0);" (click)="onLinkAbout('equipo')">
                  Visión
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 mt-lg-0 mt-4">
          <div class="footer-lavi ">
            <h3 class="mb-3 footer_title" [ngStyle]="{'color': sectionFooter.color_title}">HERRAMIENTAS</h3>
            <ul class="footer-list-info  pt-3">
              <li>
                <a target="_blank" href="https://drive.google.com/drive/folders/14NX3IKh8NNVVJE5n_AT23uyioo7SSGte">
                  Flyers
                </a>
              </li>
              <li>
                <a target="_blank" href="https://legacy.moebius.tur.ar/eventos">
                  Eventos
                </a>
              </li>
              <li>
                 <a target="_blank" [href]="getClientsSettingAppBooking?.clients_setting_social_networks[3]?.url">
                  Redes Sociales
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-2 col-sm-6 mt-lg-0 mt-4" id="element-product-footer">
          <div class="footer-lavi">
            <div class="footer-lavi ">
              <h3 class="mb-3 footer_title" [ngStyle]="{'color': sectionFooter.color_title}">PRODUCTOS</h3>
              <ul class="footer-list-info  pt-3">
                <li>
                  <a href="javascript:void(0);" (click)="mannagementRedirect('national', 2)">
                    Hoteles
                  </a>
                </li>
                 <li>
                  <a href="javascript:void(0);" (click)="mannagementRedirect('national', 2)">
                    Traslados
                  </a>
                </li>
                 <li>
                  <a href="javascript:void(0);" (click)="mannagementRedirect('national', 2)">
                    Excursiones
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" (click)="mannagementRedirect('circuit', 2)">
                    Circuitos
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" (click)="mannagementRedirect('rate', 2)">
                    Tarifario
                  </a>
                </li>
                 <li>
                  <a href="javascript:void(0);" (click)="mannagementRedirect('deals', 2)">
                    Promociones
                  </a>
                </li>

              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-sm-6 mt-lg-0 mt-4 px-0 pl-3">
          <div class="footer-lavi">
            <div class="footer-lavi ">
              <h3 class="mb-3 footer_title" [ngStyle]="{'color': sectionFooter.color_title}">SEGMENTOS</h3>
              <ul class="footer-list-info  pt-3">
                <li>
                  <a href="javascript:void(0);" (click)="articleRedirect(1)">
                    Leisure
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" (click)="articleRedirect(2)">
                    Luxury
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" (click)="articleRedirect(3)">
                    Mice y Grupos
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" (click)="articleRedirect(4)">
                   Turismo médico
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" (click)="articleRedirect(5)">
                    Deportes
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" (click)="articleRedirect(6)">
                    Bodas
                  </a>
                </li>
                 <li>
                  <a href="javascript:void(0);" (click)="articleRedirect(7)">
                    Corporativo
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 mt-lg-0 mt-4">
          <div class="footer-lavi">
            <div class="footer-lavi ">
              <h3 class="mb-3 footer_title" [ngStyle]="{'color': sectionFooter.color_title}">CONTÁCTANOS</h3>
              <ul class="footer-list-info  pt-3">
                <ng-container *ngFor="let contact of sectionFooter?.info?.contacts">
                  <li>
                    <a href="">{{contact.code_phone}}: {{contact.phone}}</a>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-dowp container d-flex align-items-center"
      [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}"> <!--Luego borrar-->
      <a href="https://www.fusionpax.com/" target="_blank" class="d-flex align-items-center" style="text-decoration: none;gap: .25em">
         <img src="../../../../assets/icons/FUSION_bco.svg" class="ml-5" style="width: 50px" alt="">
        <p class="ml-1 mb-0" style="font-family: 'Poppins', sans-serif;font-size: 14px;font-weight: 400; color:white;margin-top:2px"> 2018 - {{currentYear}} ©</p>
      </a>
    </div>
  </div>
  <div class="container mx-auto" id="adjust-footer">
  </div>
  <div id="footer-space" [ngStyle]="{'margin-bottom': isHome ? '400px' : '0px'}"></div>
  <div class="row" id="adjust-footer">
  </div>

  <!-- //footer bottom -->
</footer>

